import React from 'react';
import useStyles from './useStyles';
import Dictionary from '../../utils/dictionary';
import useDictionary from '../../hooks/useDictionary';
import { ReactComponent as AirplaneSvg } from '../../assets/svg/airplane-cel.svg';
import { ReactComponent as FlightBySvg } from '../../assets/svg/flights-by-celebrity.svg';
import { ReactComponent as PriceSvg } from '../../assets/svg/price-cel.svg';
import { ReactComponent as ProtectionSvg } from '../../assets/svg/protection-cel.svg';
import { ReactComponent as PayLaterSvg } from '../../assets/svg/pay-later-cel.svg';
import { ReactComponent as PointsSvg } from '../../assets/svg/points-cel.svg';

const WhyChooseUsCel = () => {
  const classes = useStyles();
  const getDictionary = useDictionary(Dictionary);

  const tabType = new URLSearchParams(window.location.search).get('booking');
  const { hash } = window.location;

  React.useEffect(() => {
    const section = document.getElementById('whyChooseUs');
    if (hash === '#whyChooseUs' && tabType === 'browse' && section) section.scrollIntoView();
  }, [hash, tabType]);

  return (
    <div className={classes.whyChooseUs} id="whyChooseUs">
      <div className={classes.sectionWrapper}>
        <div className={classes.reasonsText}>
          <h4> {getDictionary(Dictionary.airFlightBookFlightsWhyChooseUsTitle.key)} </h4>
          <p> {getDictionary(Dictionary.airBookFlightWhyChooseUsReason1Cel.key)} </p>
          <p> {getDictionary(Dictionary.airBookFlightWhyChooseUsReason2Cel.key)} </p>
          <p> {getDictionary(Dictionary.airBookFlightWhyChooseUsReason3Cel.key)} </p>
        </div>
        <section className={classes.reasonsIconWrapper}>
          <div className={classes.reasonsIconFlightBy}>
            <AirplaneSvg />
            <FlightBySvg />
          </div>
          <h4>{getDictionary(Dictionary.airBookFlightWhyChooseUsFlightsByText.key)} </h4>
          <div className={classes.reasonsIconList}>
            <div className={classes.reasonsIcon}>
              <PriceSvg />
              <h5>{getDictionary(Dictionary.airBookFlightWhyChooseUsPriceTitle.key)}</h5>
              <p>{getDictionary(Dictionary.airBookFlightWhyChooseUsPriceText.key)}</p>
            </div>
            <div className={classes.reasonsIcon}>
              <ProtectionSvg />
              <h5>{getDictionary(Dictionary.airBookFlightWhyChooseUsProtectionTitle.key)}</h5>
              <p>{getDictionary(Dictionary.airBookFlightWhyChooseUsProtectionText.key)}</p>
            </div>
            <div className={classes.reasonsIcon}>
              <PayLaterSvg />
              <h5>{getDictionary(Dictionary.airBookFlightWhyChooseUsPayLaterTitle.key)}</h5>
              <p>{getDictionary(Dictionary.airBookFlightWhyChooseUsPayLaterText.key)}</p>
            </div>
            <div className={classes.reasonsIcon}>
              <PointsSvg />
              <h5>{getDictionary(Dictionary.airBookFlightWhyChooseUsPointsTitle.key)}</h5>
              <p>{getDictionary(Dictionary.airBookFlightWhyChooseUsPointsText.key)}</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default WhyChooseUsCel;
